import {
  getIDToken,
  setIDToken,
  setActiveUser,
  getActiveUser,
} from "utils/utils";
import * as actions from "../actions/users";

const INITIAL_STATE = {
  activeUser: getActiveUser(),
  token: getIDToken(),
  error: null,
  users: [],
  savedUser: null,
  saving: false,
  user: null,
  userTypes: [],
};

const users = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        activeUser: action.user,
        token: action.token,
        error: null,
      };
    case actions.LOGIN_ERROR:
      return {
        ...state,
        activeUser: null,
        token: null,
        error: action.error,
      };
    case actions.LOGOUT_SUCCESS:
      setActiveUser(null);
      setIDToken(null);
      return {
        ...state,
        activeUser: null,
        token: null,
        error: null,
      };
    case actions.RETRIEVED_USERS:
      return {
        ...state,
        users: action.users,
      };
    case actions.SAVING_USER:
      return {
        ...state,
        saving: action.saving,
      };
    case actions.SAVED_USER:
      return {
        ...state,
        saving: false,
        savedUser: action.savedUser,
        user: action.savedUser,
      };
    case actions.CLEAR_SAVED_USER:
      return {
        ...state,
        savedUser: null,
        user: null,
      };
    case actions.RETRIEVED_USER_TYPES:
      return {
        ...state,
        userTypes: action.userTypes,
      };
    case actions.RETRIEVED_USER:
      return {
        ...state,
        user: action.user,
      };
    default:
      return state;
  }
};

export default users;
